import { SVGProps } from "react";

const UploadIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 25, height = 25 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1897_29238)">
        <mask
          id="mask0_1897_29238"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="25"
        >
          <path
            d="M8.5 16.9915V24.9915H0.5V0.991455H24.5V24.9915H16.5V16.9915H8.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1897_29238)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.7 12.4915C2.7 15.9708 5.52061 18.7915 9 18.7915H18C20.3748 18.7915 22.3 16.8663 22.3 14.4915C22.3 12.1166 20.3748 10.1915 18 10.1915C17.4279 10.1915 16.8847 10.3025 16.3887 10.5032C15.7474 10.7626 15.0117 10.4755 14.7187 9.84398C13.7171 7.68485 11.5317 6.19146 9 6.19146C5.52061 6.19146 2.7 9.01206 2.7 12.4915ZM9 19.9915C4.85786 19.9915 1.5 16.6336 1.5 12.4915C1.5 8.34932 4.85786 4.99146 9 4.99146C12.0161 4.99146 14.6164 6.77185 15.8073 9.33902C15.8302 9.38845 15.8881 9.41121 15.9387 9.39078C16.5753 9.13326 17.2711 8.99146 18 8.99146C21.0376 8.99146 23.5 11.4539 23.5 14.4915C23.5 17.529 21.0376 19.9915 18 19.9915H9Z"
            fill="black"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9 23.9915L11.9 15.9915L13.1 15.9915L13.1 23.9915L11.9 23.9915Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 15.9915L15.5 15.9915L12.5 12.9915L9.5 15.9915Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1897_29238">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5 0.991455)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UploadIcon;
